import { render, staticRenderFns } from "./KlasusLevel6.vue?vue&type=template&id=41ad4e62&scoped=true"
import script from "./KlasusLevel6.vue?vue&type=script&lang=js"
export * from "./KlasusLevel6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ad4e62",
  null
  
)

export default component.exports